export default [
  /**
   * 学习-学习首页
   */
  {
    path: '/study/index',
    name: 'StudyIndex',
    component: (resolve) => require(['@/views/study/index'], resolve),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/study/course',
    name: 'StudyCourse',
    component: (resolve) => require(['@/views/study/course'], resolve),
    meta: {
      keepAlive: true
    }
  },
  /**
   * 我的课程
   */
  {
    path: '/study/my-course',
    name: 'StudyMyCourse',
    component: (resolve) => require(['@/views/study/my-course'], resolve)
  },
  /**
   * 课程详情
   */
  {
    path: '/study/details',
    name: 'StudyDetails',
    component: (resolve) => require(['@/views/study/details'], resolve)
  },
  /**
   * 录播课视频学习
   */
  {
    path: '/study/recordStudy',
    name: 'RecordStudy',
    component: (resolve) => require(['@/views/study/record-study'], resolve)
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/study.js